import axios from "axios";
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState
} from "react";
import { ICurrentUser } from "types/ICurrentUser";

interface ICurrentUserContext {
  currentUser: ICurrentUser | null;
  setCurrentUser: React.Dispatch<React.SetStateAction<ICurrentUser | null>>;
}

interface ICurrentUserProviderParams {
  children: ReactNode;
  chatId: string;
  adminId: string;
  customerId: string;
}

const CurrentUserContext = createContext<ICurrentUserContext>(
  {} as ICurrentUserContext
);
const useCurrentUserContext = () =>
  useContext<ICurrentUserContext>(CurrentUserContext);

const CurrentUserProvider = ({
  children,
  chatId,
  adminId,
  customerId
}: ICurrentUserProviderParams) => {
  const [currentUser, setCurrentUser] = useState<ICurrentUser | null>(null);

  useEffect(() => {
    if (adminId) {
      setCurrentUser({
        id: adminId,
        type: "agent",
        name: "Admin"
      });
    }
    // } else if (customerId) {
    //   console.log("here");
    //   axios
    //     .get(
    //       `/api/v2/chatapp/user-chat/get-user-details?customerId=${customerId}`
    //     )
    //     .then(({ data }) => {
    //       setCurrentUser({
    //         id: customerId,
    //         type: "user",
    //         name: data.name
    //       });
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       setCurrentUser(null);
    //     });
    // }
    // } else {
    //   axios
    //     .get(`/api/v2/chatapp/user-chat/get-user?chatId=${chatId}`)
    //     .then(({ data }) => {
    //       setCurrentUser({
    //         id: data._id,
    //         type: "user",
    //         name: "Anonymous"
    //       });
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       setCurrentUser(null);
    //     });
    // }
  }, [adminId]);

  return (
    <CurrentUserContext.Provider value={{ currentUser, setCurrentUser }}>
      {children}
    </CurrentUserContext.Provider>
  );
};

export { useCurrentUserContext, CurrentUserProvider };
